<mat-form-field appearance="outline" class="full-width" [ngClass]="{'error-border': control.invalid && (control.dirty || isSubmit)}">
    <!-- <mat-label>{{ label }}</mat-label> -->
     <div style="display: flex; align-items: center;">
        <img *ngIf="icon"  src="../../../../assets/images/svgs/basil_user-solid.svg" alt="" style="margin-right: 11px;">
        <input matInput [type]="'text'" id="user" name="email" [placeholder]="placeholder" [formControl]="control"
            [readonly]="isReadonly" (focus)="isReadonly = false" autocomplete="off"/>
     </div>
   
     
        <!-- <mat-error *ngIf="control?.hasError('invalidEmail') && !control?.hasError('required')">
            Định dạng email không hợp lệ.
        </mat-error>

    <mat-error *ngIf="control?.hasError('required') && (control?.dirty || isSubmit)">
        {{errorMessage}}
    </mat-error> -->
    <mat-error *ngIf="(control?.dirty || isSubmit || isAddUserPage)">
        <span *ngIf="control?.hasError('required')" class="errorTxt">
            {{ isAddUserPage ? 'Vui lòng nhập địa chỉ email!' : 'Tài khoản không được để trống.' }}
        </span>
        <span *ngIf="control?.hasError('invalidEmail') && !control?.hasError('required')" class="errorTxt">
            Định dạng email không hợp lệ.
        </span>
    </mat-error>
</mat-form-field>
